<script>
import Layout from '@layouts/main'

export default {
  page: {
    title: 'Loading page...',
    meta: [{ name: 'description', content: 'Loading page...' }],
  },
  name: 'Loading',
  components: { Layout },
  data() {
    return {
      loadingWidthValue: '',
      loadingHeightValue: '',

    }
  },
  created() {
    window.addEventListener("resize", this.loadingCenter)
    this.loadingCenter()  
  },
  destroyed() {
    window.removeEventListener("resize", this.loadingCenter);
  },    
  methods: {
    loadingCenter() {
      this.loadingWidthValue = (window.innerWidth / 2) - 68.89
      this.loadingHeightValue = (window.innerHeight / 2) - 69.5
    },
  }  
}
</script>

<template>
  <Layout>
    <div class="preloader">
      <div class="status m-0" :style="{ top: loadingHeightValue + 'px', left: loadingWidthValue + 'px' }">
        <div class="text-center mb-3">
          <img :src="require('@assets/images/logoCJ.png')" alt height="70" />
          <br>
          <h5 class="mb-0">โปรดรอสักครู่</h5>          
        </div>       
        <div class="text-center spinner">
          <div class="circle1"></div>
          <div class="circle2"></div>
          <div class="circle3"></div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
.loadingIcon {
  display: block;
  margin: 0 auto;

  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter-active) {
    transition: opacity 1s;
  }
  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter) {
    opacity: 0;
  }
}
</style>
